import api from '../utils/api';

export function signUpRequest(params) {
  return api('https://tmcfalumniconnect.com:4000/api/TmcfLandings', params);
}
